import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const accepted = localStorage.getItem('cookies-accepted');
    if (accepted === 'true') {
      setShow(false);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookies-accepted', 'true');
    setShow(false);
  };

  const refuseAll = () => {
    localStorage.setItem('cookies-accepted', 'true');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] animate-slideUp">
      <div className="bg-[#0a0a0a]/95 backdrop-blur-xl border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 md:py-5">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <div className="flex items-start gap-3 flex-1">
              <div className="w-9 h-9 rounded-lg bg-brand/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-shield-check-line text-brand text-lg"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-white mb-0.5">
                  Nous respectons votre vie privée
                </h4>
                <p className="text-xs text-white/60 leading-relaxed max-w-2xl">
                  Nous utilisons des cookies pour améliorer votre expérience de navigation, analyser le trafic et personnaliser le contenu. Vous pouvez les accepter ou les refuser.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0 w-full md:w-auto">
              <button
                onClick={refuseAll}
                className="flex-1 md:flex-none px-6 py-2.5 rounded-full text-xs font-semibold border border-white/20 text-white/80 hover:bg-white/10 hover:text-white transition-all duration-300 whitespace-nowrap"
              >
                Refuser
              </button>
              <button
                onClick={acceptAll}
                className="flex-1 md:flex-none px-6 py-2.5 rounded-full text-xs font-semibold bg-brand text-dark hover:bg-brand/90 transition-all duration-300 whitespace-nowrap"
              >
                Accepter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}